interface Request extends RequestInit {
	params?: URLSearchParams;
}

const enableMarketSuiteCache =
	process.env.NEXT_PUBLIC_ENABLE_MARKETSUITE_CACHE === undefined ? true : process.env.NEXT_PUBLIC_ENABLE_MARKETSUITE_CACHE === "true";

/**
 * Sends a request to the Marketsuite API via the /api/ms proxy route.
 *
 * The proxy attaches the API key server-side, so no credentials are
 * needed or exposed on the client.
 *
 * @param url - The Marketsuite API path to request. A leading slash is stripped automatically.
 * @param init - Optional fetch options
 * @returns The parsed JSON response, or null when the request fails.
 */
export async function sendMarketSuiteRequest<T>(url: string, init?: Request): Promise<T | null> {
	let formattedUrl = `/api/ms/${url.replace(/^\//, "")}`;

	if (!enableMarketSuiteCache) {
		init ??= {};
		init.params ??= new URLSearchParams();
		init.params.set("cache", "false");
	}

	if (init?.params) formattedUrl += `?${init.params.toString()}`;

	const response = await fetch(formattedUrl, init);

	if (!response.ok) {
		console.error(`Request failed: ${response.status} ${response.statusText} (${formattedUrl})`);
		return null;
	}

	return response.json() as Promise<T>;
}
